import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import Column from '@amzn/meridian/column';
import Text from '@amzn/meridian/text';
import Row from '@amzn/meridian/row';
import { ProductCard } from 'src/common/productCard';
import { ScrollableRow, SectionDivider } from 'src/common/styled';
import { useProductWidget, useProductRecommendations, usePageContext } from 'src/hooks';
export const ProductCarousel = ({ asin, carouselType }) => {
    const { bundle } = usePageContext();
    // Fetch data based on carouselType
    const { data: productWidget } = useProductWidget({ enabled: carouselType === 'widget' });
    const { data: productRecommendations } = useProductRecommendations({
        asin,
        enabled: carouselType === 'recommendations',
    });
    // Extract products based on carouselType
    const products = carouselType === 'recommendations' ? (productRecommendations === null || productRecommendations === void 0 ? void 0 : productRecommendations.products) || [] : (productWidget === null || productWidget === void 0 ? void 0 : productWidget.products) || [];
    const minProducts = 3;
    if (products.length < minProducts) {
        return null;
    }
    // Determine the title and testId based on carouselType
    const displayTitle = carouselType === 'recommendations'
        ? bundle.getMessage('customersWhoViewedThisAlsoViewed')
        : bundle.getMessage('moreToDiscover');
    const testId = carouselType === 'recommendations' ? 'product-recommendations-container' : 'product-widget-container';
    return (_jsxs(Column, { spacing: "none", "data-testid": testId, children: [_jsx(SectionDivider, {}), _jsx(Row, { spacingInset: "400 350 none 350", children: _jsx(Text, { type: "b400", "data-testid": `${testId}-title`, children: _jsx("b", { children: displayTitle }) }) }), _jsx(ScrollableRow, { spacingInset: "300 350 400 350", "data-testid": `${testId}-cards`, alignmentVertical: "top", children: products.map((productItem) => (_jsx(ProductCard, { productItem: productItem }, productItem.asin))) })] }));
};
